import { render, staticRenderFns } from "./tableExpand.vue?vue&type=template&id=39f568b2&scoped=true&"
import script from "./tableExpand.vue?vue&type=script&lang=js&"
export * from "./tableExpand.vue?vue&type=script&lang=js&"
import style0 from "./tableExpand.vue?vue&type=style&index=0&id=39f568b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f568b2",
  null
  
)

export default component.exports